// components
import { ColumnsType } from 'components/Table/interface'
// helpers
import StatusCell from './Cell/StatusCell'
import TagCell from './Cell/TagCell'
import MoreOptions from './Cell/MoreActions'

export const columns: ColumnsType<any> = [
  {
    title: 'Nombre',
    dataIndex: 'name',
    type: 'CommonCell'
  },
  {
    title: 'Email',
    dataIndex: 'email',
    type: 'CommonCell'
  },
  {
    title: 'Celular',
    dataIndex: 'phone',
    type: 'CommonCell'
  },
  {
    title: 'Tipo',
    dataIndex: 'type',
    width: '20rem',
    ellipsis: true,
    type: 'CommonCell'
  },
  {
    title: 'Estado',
    dataIndex: 'status',
    render: StatusCell
  },
  {
    title: 'Versión de SDK',
    dataIndex: 'sdk_version',
    render: TagCell,
    filterSearch: true,
    onFilter: (value, record) => record.name.startsWith(value as string)
  },
  {
    title: 'Fecha de creación',
    dataIndex: 'created_dt',
    type: 'date'
  },
  {
    title: 'Fecha de actualización',
    dataIndex: 'updated_dt',
    type: 'date'
  },
  {
    title: '',
    fixed: 'right',
    width: 40,
    dataIndex: 'id',
    render: MoreOptions
  }
]